<div id="orgs" class="page-layout blank simple" fxLayout="column">
  <!-- HEADER -->
  <div class="header-orgas">
    <div class="header-container">
      <div
        class="name field"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ 'GENERAL.TITLE.ORGS' | translate }}
      </div>
    </div>
    <div class="search-section">
      <div class="search-field">
        <!-- SEARCH -->
        <div class="search-wrapper">
          <div
            class="search"
            fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <input
              #filter
              matInput
              (keyup)="applyFilter($event)"
              placeholder="{{ 'TABLE.FILTER' | translate }}" />
          </div>
        </div>
        <div>
          <button
            (click)="clearFilter()"
            mat-icon-button
            aria-label="refresh"
            class="export-btn">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <!-- / SEARCH -->
      </div>
    </div>
  </div>
  <!-- / HEADER -->
  @if (isLoading) {
    <mat-progress-bar
      color="accent"
      mode="indeterminate"
      class="mat-progress-bar"></mat-progress-bar>
  }
  <div class="content" fxLayout="row wrap">
    <!-- CONTENT CARD -->
    <div fxFill class="mat-elevation-z8 content-card">
      @if (!isLoading) {
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          multiTemplateDataRows>
          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="name"
              class="sortable">
              {{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}
              <mat-icon
                [style.color]="
                  sortedValue !== 'name' ? '#757575' : 'transparent'
                "
                class="sort-icon"
                >sort</mat-icon
              >
            </th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="email"
              class="sortable">
              {{ 'USERS.SINGLE.INFO.EMAIL' | translate }}
              <mat-icon
                [style.color]="
                  sortedValue !== 'email' ? '#757575' : 'transparent'
                "
                class="sort-icon"
                >sort</mat-icon
              >
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.email }}
            </td>
          </ng-container>
          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="toggleRow(element)">
                <mat-icon>more_horiz</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
              @if (expandedElement === element && windowWidth < 650) {
                <div class="expanded-detail">
                  <p>
                    <strong
                      >{{ 'USERS.SINGLE.INFO.EMAIL' | translate }}:</strong
                    >
                    {{ element.email }}
                  </p>
                </div>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              let index = dataIndex;
              columns: displayedColumns
            "
            class="element-row"
            [ngClass]="{ alternate: index % 2 === 0 }"></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              let index = dataIndex;
              columns: ['expandedDetail']
            "
            class="detail-row"
            [ngClass]="{ alternate: index % 2 === 0 }"></tr>
        </table>
      }
      <mat-paginator
        [hidePageSize]="true"
        [pageSize]="15"
        showFirstLastButtons />
    </div>
    <!-- / CONTENT CARD -->
  </div>
</div>
